import { IconButton, Stack, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { useTranslation } from "react-i18next";
import { downloadAsXLS } from "src/utils";
import DownloadIcon from "src/assets/svg-icons/download.svg";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useDownloadItemsSalesDetails, useDownloadMenuSalesDetails } from "src/api/add-sales";

const TableActions = ({ rowId, rowRef }: { rowId: number; rowRef: string }) => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const { t } = useTranslation("settings");
  const { t: generalT } = useTranslation("general");

  const {
    data: downloadedData,
    refetch: refetchDownload,
    isFetching: isFetchingDownload,
    status: downloadStatus,
  } = useDownloadItemsSalesDetails({
    id: rowId,
  });

  const navigateToViewPage = () => {
    navigate(`/inventory/cogs/recipe/${rowId}`);
  };

  const handleDownload = () => {
    refetchDownload();
  };

  useEffect(() => {
    if (
      downloadStatus === "success" &&
      !!downloadedData &&
      !isFetchingDownload
    ) {
      const utf8CSVData = `\uFEFF${downloadedData}`;
      downloadAsXLS(utf8CSVData, `recipe-cost-${rowRef}`);
    }
  }, [isFetchingDownload]);

  return (
    <Stack
      direction={"row"}
      spacing={"12px"}
      width={"100%"}
      justifyContent={"center"}
    >
      <Tooltip title={generalT("download")}>
        <IconButton onClick={handleDownload} disabled={isFetchingDownload}>
          <img src={DownloadIcon} alt="" />
        </IconButton>
      </Tooltip>
      <Tooltip title={generalT("details")}>
        <IconButton onClick={navigateToViewPage}>
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
export default TableActions;
